'use strict';
(function () {
	angular.module('dat.shared-components.equipment')
		.factory('EquipmentService', equipmentService);

	equipmentService.$inject = ['$http', '$q', '$log'];

	function equipmentService($http, $q, $log) {
		var equipmentService = {
			getEquipmentSetData: getEquipmentSetData,
			removeClass: removeClass,
			searchClasses: searchClasses,
			searchTypes: searchTypes,
			search: search,
			getEquipmentTypes: getEquipmentTypes,
			getEquipmentClasses: getEquipmentClasses,
			getSelect2BaseOptions: getSelect2BaseOptions,
			sortClasses: sortClasses,
			sortTypes: sortTypes,
			createTypeItem: createTypeItem,
			createClassItem: createClassItem
		};

		var validFirstCharsTypes = 'ABCDFHILMNOPRSTV',
			validSecondCharsTypes = '23ABCDFGHILMNOPRSTUVWXZ',
			validSingleCharTypes = 'CFRV',
			validCharsForClasses = 'BCDFKNORSTVZ',
			typeTerm = '',
			classTerm = '',
			equipmentSetData = null,
			getEquipmentSetDataPromise;

		// Important note: It is a good idea to have the angular route resolve on equipmentService.getEquipmentSetData() if possible
		// otherwise, depending on the application using this component, there may be issues
		$log.debug('equipmentService service called');
		equipmentService.getEquipmentSetData();

		return equipmentService;

		/////////////////////////

		function sortBy(prop) {
			return function (a, b) {
				if (a[prop] > b[prop]) {
					return 1;
				} else if (a[prop] < b[prop]) {
					return -1;
				}

				return 0;
			};
		}

		function getValidDoubleTerms() {
			var result = [],
				termItem1 = typeTerm[0],
				termItem2 = typeTerm[1],
				termIndex1 = validFirstCharsTypes.indexOf(termItem1),
				termIndex2 = validSecondCharsTypes.indexOf(termItem2);

			if (termIndex1 >= 0 || termIndex2 >= 0) {
				result.push(typeTerm);
			}

			return result;
		}

		function createTypeTerms() {
			if (typeTerm.length == 1) {
				if (validSingleCharTypes.indexOf(typeTerm) >= 0) {
					return [typeTerm];
				}
			}

			if (typeTerm.length == 2) {
				return getValidDoubleTerms();
			}

			return [];
		}

		function createCompositeItem(source) {
			var compositeTerm = '',
				compositeId = '';

			angular.forEach(source, function (value) {
				if (compositeTerm === '') {
					compositeTerm += value.text;
					compositeId += value.id;
				} else {
					compositeTerm += '; ' + value.text;
					compositeId += ';' + value.id;
				}
			});

			if (compositeTerm.split(';').length === source.length) {
				return {id: compositeId, text: compositeTerm};
			} else {
				return;
			}
		}

		function areValidTerms(terms) {
			var termItem, termIndex, i;
			var validTerms = true;

			for (i = 0; i < terms.length; i++) {
				termItem = terms[i];
				termIndex = validCharsForClasses.indexOf(termItem);
				if (termIndex == -1) {
					validTerms = false;
					break;
				}
			}

			return validTerms;
		}

		function createClassTerms() {
			var terms = uniqueTerms(classTerm).split(''),
				validTerms = areValidTerms(terms);

			if (!validTerms) {
				return [];
			}

			return terms;
		}

		function uniqueTerms(term) {
			var terms = term.split('').sort(),
				len = terms.length,
				result = [];

			if (len == 2) {
				if (terms[0] === terms[1]) {
					return terms[0];
				} else {
					return term;
				}
			}

			result.push(terms[0]);

			for (var i = 1; i < len; i++) {
				if (terms[i] !== terms[i - 1]) {
					result.push(terms[i]);
				}
			}

			return result.join('');
		}

		function findByCode(code, array) {
			return _.find(array, function (equipObj) {
				return equipObj.id == code;
			});
		}

		function findByCodesArray(codesArray, array) {
			var results = [], match;

			angular.forEach(codesArray, function (code) {
				match = findByCode(code, array);
				if (match) {
					results.push(match);
				}
			});

			return results;
		}

		function getEquipmentSetData() {
			$log.debug('getEquipmentSetData called');

			return $q.when(equipmentSetData || getEquipmentSetDataPromise || getEquipmentSet());

			function getEquipmentSet() {
				var deferred = $q.defer();
				getEquipmentSetDataPromise = deferred.promise;
				$http.get('../api/equipment/equipmentOptions').then(function (result) {
					$log.debug('getEquipmentSetData: Received equipment response');
					equipmentSetData = result.data;
					deferred.resolve(equipmentSetData);
				});

				return deferred.promise;
			}
		}

		function removeClass(name) {
			equipmentSetData.classes = _.reject(equipmentSetData.classes, function (classObj) {
				return classObj.id == name;
			});
		}

		function search(query, array) {
			var data = {results: []};
			angular.forEach(array, function (item) {
				if (item.id.toUpperCase().indexOf(query.term.toUpperCase()) >= 0 || item.text.toUpperCase().indexOf(query.term.toUpperCase()) >= 0) {
					data.results.push(item);
				}
			});

			return data;
		}

		function searchClasses(query) {
			$q.when(getEquipmentSetDataPromise)
				.then(function() {
					var data = equipmentService.search(query, equipmentSetData.classes);
					query.callback(data);
				});
		}

		function searchTypes(query) {
			$q.when(getEquipmentSetDataPromise)
				.then(function() {
					var data = equipmentService.search(query, equipmentSetData.types);
					query.callback(data);
				});
		}

		function getEquipmentTypes(codes) {
			return findByCodesArray(codes, equipmentSetData.types);
		}

		function getEquipmentClasses(codes) {
			return findByCodesArray(codes, equipmentSetData.classes);
		}

		function getSelect2BaseOptions() {
			var options = {
				dropdownCssClass: 'bigdrop', // apply css class to make dropdown taller
				multiple: true,
				width: '125px',
				dropdownAutoWidth: true,
				closeOnSelect: true,
				allowClear: false,
				openOnEnter: true,
				closeOnTabOut: true,
				formatSelection: function (item) {
					return item.id;
				},
				formatResult: function (item, container, query) {
					var re = new RegExp('(' + query.term + ')', 'gi');
					var text = item.text.replace(re, '<b>$1</b>');

					return '<div class="select2-cf"><div class="select2-formatresult-code">' + item.id + '</div><div class="select2-formatresult-text">' + text + '</div></div>';
				}
			};

			return options;
		}

		function sortClasses(results, container, query) {
			if (!query.term || query.term.length != 1) {
				return results.sort(sortBy('text'));
			}

			var term = query.term.toUpperCase();
			var i, item, len = results.length;
			var finalResults = [], unmatched = [];

			for (i = 0; i < len; i++) {
				item = results[i];
				if (term == item.id) {
					finalResults.push(item);
					continue;
				}
				unmatched.push(item);
			}

			unmatched.sort(sortBy('text'));
			finalResults = finalResults.concat(unmatched);

			return finalResults;
		}

		function sortTypes(results, container, query) {
			if (query.term) {
				if (query.term.length == 1 || query.term.length == 2) {
					var i, item;
					var items = equipmentSetData.types,
						len = items.length,
						term = query.term.toUpperCase(),
						firstLetter = query.term[0].toUpperCase(),
						finalResults = [],
						firstLetterMatches = [],
						unmatched = [];

					for (i = 0; i < len; i++) {
						item = items[i];
						if (term == item.id) {
							finalResults.push(item);
							continue;
						}
						if (firstLetter == item.id[0]) {
							firstLetterMatches.push(item);
							continue;
						}
						unmatched.push(item);
					}

					firstLetterMatches.sort(sortBy('id'));
					unmatched.sort(sortBy('text'));

					//If we have an exact match on a two character terms, just return items that match the first
					//letter of the search term
					if (query.term.length == 2 && finalResults.length == 1) {
						unmatched = [];
					}

					finalResults = finalResults.concat(firstLetterMatches).concat(unmatched);

					return finalResults;
				} else {
					return results.sort(sortBy('text'));
				}
			}

			return results;
		}

		function createTypeItem(term, selectedEquipment) {
			if (term.length >= 1) {
				typeTerm = term.toUpperCase();
				var match,
					terms = createTypeTerms();

				if (terms.length != 1) {
					return;
				}

				match = findByCode(terms[0], equipmentSetData.types);
				if (match) {
					if (!findByCode(match.id, selectedEquipment)) {
						return match;
					}
				}
			}

			return;
		}

		function createClassItem(term, selectedEquipment) {
			if (term.length >= 1) {
				var match, terms, matches = [];

				classTerm = term.toUpperCase();
				terms = createClassTerms();

				angular.forEach(terms, function (value) {
					match = findByCode(value, equipmentSetData.classes);
					if (match) {
						if (!findByCode(match.id, selectedEquipment)) {
							matches.push(match);
						}
					}
				});

				var compositeItem = createCompositeItem(matches);
				if (compositeItem) {
					return compositeItem;
				}
			}

			return;

		}
	}
})();
